import { observer } from "mobx-react-lite"
import { useProposalsEditDetailsStore } from "./ProposalsEditDetailsStore"
import AutocompleteSingleNonClearable from "reusable/mui/auto-complete/AutocompleteSingleNonClearable"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import DatePicker from "reusable/mui/date-pickers/DatePicker"

export default observer(function ProposalsEditDetailsTiming() {
   return (
      <>
         <Typography variant="subtitle1">Choose a start time</Typography>
         <Typography variant="caption">Specify when you plan to kick things off with your client.</Typography>

         <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={6}>
               <Timing />
            </Grid>
            <Grid size={6}>
               <DuringMonth />
            </Grid>
         </Grid>
      </>
   );
})

const Timing = observer(function Timing() {
   const proposalsEditDetailsStore = useProposalsEditDetailsStore()

   return proposalsEditDetailsStore.formHandler.timing.bindInput(ip =>
      <AutocompleteSingleNonClearable
         variant='outlined'
         label="Timing"
         options={proposalsEditDetailsStore.timingOptions}
         {...ip}
      />
   )
})

const DuringMonth = observer(function DuringMonth() {
   const proposalsEditDetailsStore = useProposalsEditDetailsStore()

   if (proposalsEditDetailsStore.fields.timing !== 'during-a-given-month') {
      return null
   }

   return proposalsEditDetailsStore.formHandler.duringMonth.bindInput(ip =>
      <DatePicker disablePast
         views={['month', 'year']}
         withTime={false}
         slotProps={{
            textField: {
               InputProps: {
                  value: proposalsEditDetailsStore.datePickerValue || '',
                  placeholder: proposalsEditDetailsStore.datePickerValue ? '' : proposalsEditDetailsStore.duringMonthPlaceHolder,
               },
               label: proposalsEditDetailsStore.datePickerValue ? null : 'Month of year'
            },
         }}
         clearable
         fullWidth
         {...ip}
      />
   )
})
